/* eslint-disable */
import React, { Component } from 'react';
import {Switch} from 'react-router';
import {Route, BrowserRouter} from 'react-router-dom';

import NavbarComputer from './NavbarComputer';
import NavbarMobile from './NavbarMobile';
import Footer from './Footer';
import About from './About/About.js';
import Privacy from './Legal/Privacy';
import Licenses from './Legal/Licenses';
import Home from './Home/Home.js';
import Terms from './Legal/Terms.js';
import NotFound from './NotFound.js';
import FAQ from './FAQ.js';

class Routes extends Component {
  render() {
    return (
      <BrowserRouter>
        <div>
          <NavbarComputer />
          <NavbarMobile />
          <Switch>
            <Route exact path='/' render={() => <Home />}/>
            <Route exact path='/home' render={() => <Home />}/>
            <Route exact path='/about' render={() => <About />}/>
            <Route exact path ='/faq' render={() => <FAQ />}/>
            <Route exact path='/licenses' render={() => <Licenses />}/>
            <Route exact path='/privacy' render={() => <Privacy />}/>
            <Route exact path='/terms' render={() => <Terms />}/>
            <Route path='*' status={404} component={NotFound} />
            <Route status={404} component={NotFound} />
          </Switch>
          <Footer />
        </div>
      </BrowserRouter>
    );
  }
};

export default Routes;



// WEBPACK FOOTER //
// ./src/js/Routes.js